import { EventEmitter } from 'events';
import WebBluetooth from './WebBluetooth';
import {connect} from 'react-redux';
import { bluetoothConnection } from '../actions/bluetooth.actions';
import { Dispatch } from 'redux';
import { handleActivityStatus } from '../actions/activities.actions';

export let wasPreviouslyConnected = false;
export const weightEmitter = new EventEmitter();
let sendData = false;
export default class BluetoothWrapper {
  devicePlatForm: string;

  bluetoothWeb: WebBluetooth;

  weightData: number;

  dataCallBack: any;

  connected: boolean;


  constructor(dataCallback) {
    this.dataCallBack = dataCallback;
    this.connected = false;
    
    try {
      // Always use WebBluetooth for web applications
      this.bluetoothWeb = new WebBluetooth(weightEmitter);
      this.devicePlatForm = "web";
    } catch (error) {
      console.warn("Bluetooth initialization failed:", error);
      this.devicePlatForm = "unsupported";
    }
  }
  async init(){
    if (this.devicePlatForm === 'unsupported') {
      throw new Error("Bluetooth is not supported in this environment. The app cannot run without Bluetooth functionality.");
    }
    
    // For web platform, try to connect automatically
    try {
      await this.connect();
    } catch (error) {
      console.warn("BluetoothWrapper: Auto-connect failed:", error);
      // Don't throw error, just log it - user can manually connect later
    }
  }
  connect() {
    return new Promise(async (resolve, reject) => {
      if (this.devicePlatForm === 'web') {
        this.bluetoothWeb.discoverDevicesOrDisconnect().then(() => {
          this.connected = true;
          resolve("")
        }).catch((err) => {
          console.error("BluetoothWrapper: WebBluetooth connection failed:", err);
          reject(err);
        });
      } else {
        reject(new Error("Unsupported platform: " + this.devicePlatForm));
      }
    });
  }

  disconnect() {
    if (this.devicePlatForm === 'web') {
      this.bluetoothWeb.disconnect().then(() => {
        this.connected = false;
      });
    } else {
      console.warn("BluetoothWrapper: Disconnect called on unsupported platform:", this.devicePlatForm);
      this.connected = false;
    }
  }

  isConnected() {
    return this.connected;
  }

  bindOnEventEmit(callback) {
    weightEmitter.on('weightData', data=>{
      callback(data);
    });
  }

  removeListener() {
    weightEmitter.removeAllListeners('weightData');
  }

  addNotifications = async ()=>{
    if (this.devicePlatForm === 'web') {
      sendData = true;
      
      // Check if notifications are already enabled to avoid toggling them off
      if (!this.bluetoothWeb.notificationsEnabled) {
        this.bluetoothWeb.toggleWeightDataNotifications(this.weightDataArrival);
      }
    }
  }
  resetNotifications = async ()=>{
    if (this.devicePlatForm === 'web') {
      sendData = false;
      // Simply stop sending data - the WebBluetooth notifications will continue
      // but no data will be processed since sendData is false
    } else {
      console.warn('BluetoothWrapper: Reset notifications called on unsupported platform:', this.devicePlatForm);
    }
  }
  removeStream = () =>{
    sendData = false;
  }
  weightDataArrival = (result) => {
    try {
      //const bytes = this.bluetoothCapacitor.encodedStringToBytes(result.value);
      //const dataview = new DataView(bytes.buffer);
      if(sendData){
        this.weightData = result.getUint16(0) / 100;
        this.dataCallBack(this.weightData);
      }
      
      //this.eventEmitter.emit('weightData', this.weightData);
    } catch (error) {
      console.error('BluetoothWrapper: Error in decoding weight data:', error);
    }
  }
}
